import { render, staticRenderFns } from "./GenericBlock.vue?vue&type=template&id=625ec15b&"
import script from "./GenericBlock.vue?vue&type=script&lang=js&"
export * from "./GenericBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625ec15b')) {
      api.createRecord('625ec15b', component.options)
    } else {
      api.reload('625ec15b', component.options)
    }
    module.hot.accept("./GenericBlock.vue?vue&type=template&id=625ec15b&", function () {
      api.rerender('625ec15b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/GenericBlock.vue"
export default component.exports